import React from 'react';
import PropTypes from 'prop-types';
import Message from '../../../../components/message/Message';
import TextBlock from '../text-block/TextBlock';
import Block from '../../../block/Block';
import useDevice from '../../../hooks/use-device';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './EmergencyMessage.less';

var EmergencyMessage = function EmergencyMessage(_ref) {
  var data = _ref.data;
  var device = useDevice();
  var classNames = getClasses({
    styles: styles,
    classes: ['buttonWrapper'],
    device: device
  });
  return data ? /*#__PURE__*/React.createElement(Block, {
    className: classNames
  }, /*#__PURE__*/React.createElement(Message, {
    level: "alert",
    flex: true,
    basisZero: true,
    filled: false,
    dark: false,
    inline: false
  }, /*#__PURE__*/React.createElement(TextBlock, {
    data: data,
    textNodeWrapperElement: 'span'
  }))) : null;
};

EmergencyMessage.propTypes = {
  data: PropTypes.object.isRequired
};
export default EmergencyMessage;